// extracted by css-extract-rspack-plugin
export default {"topHeader":"header-fragment__TopHeader_topHeader__qzbtP"};